import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderKirovograd(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-kirovograd/create-distribution-order-kirovograd",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderKirovograd(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-kirovograd/create-distribution-to-order-kirovograd",
      params,
      callBackFn
    );
  },
  async getKirovogradAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-kirovograd/get-kirovograd-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
